import Request from '../Request';
import EndPoints, { applyPathVariables } from '../EndPoints';
import Methods from '../Methods';
/**
 *
 * @param address String
 * @return {Promise<any>|Promise}
 */
export default (function (address) {
    var url = applyPathVariables(EndPoints.AZURE_MAPS_ADDRESS, { address: address });
    var request = new Request({ method: Methods.GET, url: url, withCredentials: false, ignorePrefix: true });
    return request.execute();
});
